import { render, staticRenderFns } from "./TemplateLogin.vue?vue&type=template&id=0c45e593&scoped=true"
import script from "./TemplateLogin.vue?vue&type=script&lang=js"
export * from "./TemplateLogin.vue?vue&type=script&lang=js"
import style0 from "./TemplateLogin.vue?vue&type=style&index=0&id=0c45e593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45e593",
  null
  
)

export default component.exports